@for (dayOfRace of dayOfRaces; track $index) {
    <ng-container>
        <div
            [ngClass]="{
                'fixture-meeting-switcher': dayOfRaces[0].dayRaceModel.fixtures.length > 0 && dayOfRaces[1].dayRaceModel.fixtures.length === 0,
            }">
            @if (dayOfRace.dayRaceModel?.fixtures.length) {
                <ms-greyhounds-meeting-switcher
                    [dayOfRace]="dayOfRace.dayRaceModel"
                    [filter]="dayOfRace.day"
                    [sportId]="sport"></ms-greyhounds-meeting-switcher>
            }
        </div>
    </ng-container>
}
